export default "__VITE_ASSET__BvDP0Wi$__"